import * as query from "@arcgis/core/rest/query.js";
import WinnebagoService from "./WinnebagoService"
import findZoning from "../../SummaryTools/findZoning";
export class WinPublicService extends WinnebagoService {
     

    async getSchoolDistrictInfo(geometry) {
        return new Promise((resolve, reject) => {
            query.executeQueryJSON(PublicPropertySearchService + "/26", {
                geometry: geometry, 
                outFields: ["SCHOOLDIST", "GRADESCHOOL"], 
            }, {headers: {'RequestVerificationToken': this.antiForgeryToken }}).then((results) => {
                resolve(results); 
            })
        }); 
    }

    async findZoningResults(geometry) {
        const zones = {
            "/17": ["ZoningDist"], //Rockford
            "/14": ["ZoningDistrict", "ZoningDescription"], // Loves Park
            "/15": ["ZoningCode", "ZoningClas"], // Machesney Park
            "/16": ["Zone_Code", "Zone_Class"], // Machesney Park
            "/13": ["ZoningType", "ZoningDesc"], // Cherry Valley
            "/19": ["ZoningClass", "ZoningDesc"], // Roscoe
            "/20": ["ZoningClas"], // South Beloit
            "/18": ["ZoneType", "ZoneDesc"], // Rockton
            "/21": ["ZoningAbbreviation"], // Winnebago County 
            "/22": ["ZONINGNAME"], // New Milford
            "/23": ["ZoningCode", "ZoningClas"] // Durand
        };
        return findZoning(geometry, PublicPropertySearchService, zones, this.antiForgeryToken); 
    }
}


